import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

class RadioButton extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.element,
  };

  onClick = () => {
    this.props.onChange(this.props.value);
  };

  render() {
    const { children, onChange, ...rest } = this.props;
    const checked = this.props.checked || false;
    return (
      <RadioCont
        checked={checked}
        onClick={this.onClick}
      >
        {children}
        <Input type="radio" onChange={() => null} {...rest} />
      </RadioCont>
    );
  }
}

const RadioCont = styled.div`
  position: relative;
  display: inline-block;
  text-align: center;
  flex-grow: 0;
  flex-shrink: 0;
  font-weight: 500;
  padding: 6px 9px;
  font-size: 13px;
  border-radius: 100px;
  margin-right: 9px;
  background: ${p => p.theme.colors.gray.lighter};
  &:hover {
    background: ${p => p.theme.colors.primary};
    color: white;
  }
  ${p =>
    p.checked &&
  css`
      background: ${p => p.theme.colors.primary};
      color: white;
    `};
  ${p => p.theme.max('sm')`
    padding: 7px;
  `}
`;

const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export default RadioButton;
